import React from "react"
import PropTypes from "prop-types"
import RaisedButton from "material-ui/RaisedButton"

import TextField from "material-ui/TextField"
import FlatButton from "material-ui/FlatButton"

import BirthdayField from "../../../../components/misc/BirthdayField"
import SocialSecurityNumberField from "../../../../components/misc/SocialSecurityNumberField"
import EmailField from "../../../../components/misc/EmailField"

const i9Actions = require("../../../../actions/I9Actions")
const utils = require("../../../../helpers/utils")
const moment = require("moment")

const propTypes = {
    i9: PropTypes.object,
    onValueChange: PropTypes.func
}

export default class I9PersonalInfo extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            i9: null,
            bdayValid: false
        }
        this.handleBirthdayChange = this.handleBirthdayChange.bind(this)
        this.handleSSNChange = this.handleSSNChange.bind(this)
        this.handleEmailChange = this.handleEmailChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            const bday = moment(nextProps.i9.Employee_BirthDate)

            this.setState({
                i9: nextProps.i9,
                bdayValid: bday.year() > 1900
            })
        }
    }

    handleSSNChange(value, valid) {
        this.state.i9.Employee_USSocialSecurity = value
        this.state.i9.SSNChanged = true

        this.updateI9()
        if (valid) {
            i9Actions.patchSection1Data(this.state.i9.I9Id, {
                Employee_USSocialSecurity: value
            })
        }
    }

    handleBirthdayChange(value, valid) {
        this.state.i9.Employee_BirthDate = value
        this.updateI9()

        if (valid) {
            i9Actions.patchSection1Data(this.state.i9.I9Id, {
                Employee_BirthDate: value
            })
        }

        this.setState({
            bdayValid: valid
        })
    }

    handleEmailChange(value, valid) {
        this.state.i9.Employee_Email = value
        this.updateI9()
        if (valid) {
            i9Actions.patchSection1Data(this.state.i9.I9Id, {
                Employee_Email: value
            })
        }
    }

    updateI9() {
        if (this.props.onValueChange) {
            this.props.onValueChange(this.state.i9)
        }
    }

    validate(i9) {
        if (!i9) {
            return false
        }

        if (
            !this.state.bdayValid ||
            //If we've recieved SSN from the server, it hasn't changed, and it is empty, it is invalid
            (!i9.SSNChanged && i9.Employee_USSocialSecurity.toString().length === 0) ||
            (i9.SSNChanged && i9.Employee_USSocialSecurity.toString().length !== 9) ||
            (i9.Employee_Email && i9.Employee_Email.length > 0 && !utils.validateEmail(i9.Employee_Email))
        ) {
            return false
        } else {
            return true
        }
    }

    render() {
        return (
            <div className="I9PersonalInfo">
                <div style={{ marginBottom: 10 }}>
                    <b>Personal Information</b>
                </div>
                <div style={{ textAlign: "left" }}>
                    <div style={{ color: "#cccccc" }}>Your Birthday</div>
                    <BirthdayField value={this.state.i9 ? this.state.i9.Employee_BirthDate : ""} handleChange={this.handleBirthdayChange} />
                </div>
                <SocialSecurityNumberField style={{ width: "100%" }} value={this.state.i9 ? this.state.i9.Employee_USSocialSecurity : ""} handleChange={this.handleSSNChange} />
                <EmailField style={{ width: "100%" }} value={this.state.i9 ? this.state.i9.Employee_Email : ""} handleChange={this.handleEmailChange} />
                <div
                    style={{
                        textAlign: "left",
                        fontSize: 15,
                        marginTop: 10,
                        marginBottom: 10
                    }}
                >
                    Mobile Number : {this.state.i9 ? this.state.i9.Employee_TelephoneNumber : ""}
                </div>
            </div>
        )
    }
}

I9PersonalInfo.propTypes = propTypes
